import PersonIconPng from '../img/driver-modal/person.png'
import PersonIconWebp from '../img/driver-modal/person.webp'
import PhoneIconPng from '../img/driver-modal/phone.png'
import PhoneIconWebp from '../img/driver-modal/phone.webp'
import BogdanProfilePicPng from '../img/driver-modal/bogdan.png'
import BogdanProfilePicWebp from '../img/driver-modal/bogdan.webp'
import BogdanProfilePic2Png from '../img/driver-modal/bogdan-2.png'
import BogdanProfilePic2Webp from '../img/driver-modal/bogdan-2.webp'
import RobertProfilePicPng from '../img/driver-modal/robert.png'
import RobertProfilePicWebp from '../img/driver-modal/robert.webp'
import BogdanCarProfilePng from '../img/driver-modal/main-modal-dodge.png'
import BogdanCarProfileWebp from '../img/driver-modal/main-modal-dodge.webp'
import RobertCarProfilePng from '../img/driver-modal/main-modal-volvo.png'
import RobertCarProfileWebp from '../img/driver-modal/main-modal-volvo.webp'
import MapsIconPng from '../img/icons/g-maps-icon.png'
import MapsIconWebp from '../img/icons/g-maps-icon.webp'
import FacebookIconPng from '../img/icons/facebook-icon.png'
import FacebookIconWebp from '../img/icons/facebook-icon.webp'
import BochniaTaxiIconPng from '../img/icons/taxi-bochnia-icon.png'
import BochniaTaxiIconWebp from '../img/icons/taxi-bochnia-icon.webp'






export const driversData = [
    {
      name: 'Bogdan',
      car: 'Dodge Grand Caravan',
      capacity: '1-6',
      phone: '669 102 202',
      profilePicPng: BogdanProfilePic2Png,
      profilePicWebp: BogdanProfilePic2Webp,
      carPicPng: BogdanCarProfilePng,
      carPicWebp: BogdanCarProfileWebp,
      personIconPng: PersonIconPng,
      personIconWebp: PersonIconWebp,
      phoneIconPng: PhoneIconPng,
      phoneIconWebp: PhoneIconWebp,
      mainLink: 'https://maps.app.goo.gl/vgGYpyg7DjbFYkoK8',
      mainLinkMobile: 'tel:669102202', // Mobile link (Initiates phone call)
      socialIcons: [FacebookIconPng, MapsIconPng],
      socialIconsWebp: [FacebookIconWebp, MapsIconWebp],
      socialLinks: ['https://www.facebook.com/bochniataxi', 'https://maps.app.goo.gl/vgGYpyg7DjbFYkoK8']
    },
    {
      name: 'Robert',
      car: 'Volvo S90 (2024)',
      capacity: '1-4',
      phone: '534 014 014',
      profilePicPng: RobertProfilePicPng,
      profilePicWebp: RobertProfilePicWebp,
      carPicPng: RobertCarProfilePng,
      carPicWebp: RobertCarProfileWebp,
      personIconPng: PersonIconPng,
      personIconWebp: PersonIconWebp,
      phoneIconPng: PhoneIconPng,
      phoneIconWebp: PhoneIconWebp,
      mainLink: 'https://maps.app.goo.gl/f6PM2LzrwRsrpyPn7',
      mainLinkMobile: 'tel:534014014',  // Mobile link (Initiates phone call)
      socialIcons: [FacebookIconPng, MapsIconPng],
      socialIconsWebp: [FacebookIconWebp, MapsIconWebp],
      socialLinks: ['https://www.facebook.com/taxibochnia' , 'https://maps.app.goo.gl/f6PM2LzrwRsrpyPn7'],
    },
  ];